import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  DatePicker,
  Input,
  Upload,
  Row,
  Col,
  message,
  notification,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import { getUserInfo } from "redux/selectors";
import { STATUS_CODE } from "common/Constants";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";

const ModalWrap = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
  }
  .ant-modal-body {
    padding: 0px 24px 24px 24px;
  }
  .custom-upload .ant-upload {
    width: 100%;
  }

  .upload-box {
    width: 100%;
    height: 42px;
    border-radius: 12px;
    background: #cfd6ff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid #cfd6ff;
  }

  .upload-box:hover {
    background: #bcc6ff;
  }
`;

const { TextArea } = Input;

const ApplyWorkFromHome = ({
  open,
  onCancel,
  data = {},
  getData = () => {},
}) => {
  const [form] = Form.useForm();
  const userInfo = useSelector(getUserInfo);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialvalues] = useState({});
  const [popupOpen, setPopupOpen] = useState(false);

  console.log("userInfo-->", userInfo);

  useEffect(() => {
    if (data && Object.keys(data).length) {
      form.setFieldsValue({
        startdate: data?.wfhStartDate ? dayjs(data.wfhStartDate) : null,
        enddate: data?.wfhEndDate ? dayjs(data.wfhEndDate) : null,
        noofdays: data?.wfhNoofDays || "",
        reason: data?.wfhReason || "",
        attachment: data?.fileName
          ? [
              {
                uid: "-1",
                name: data.fileName,
                status: "done",
                url: data.fileUrl || "",
              },
            ]
          : [],
      });
    }
    // } else {
    //   form.resetFields();
    // }
  }, [data]);

  const handleFinish = async (values) => {
    try {
      setLoading(true);

      const fileList = values?.attachment || [];
      const fileObj = fileList?.[0]?.originFileObj || null;

      let uploadedKey = data?.objectKey || "";
      let fileName = data?.fileName || "";

      if (fileList.length === 0) {
        uploadedKey = "";
        fileName = "";
      }

      if (fileObj) {
        const videoTypes = [
          "video/mp4",
          "video/mpeg",
          "video/quicktime",
          "video/x-msvideo",
          "video/x-ms-wmv",
          "video/webm",
          "video/ogg",
        ];

        if (
          videoTypes.includes(fileObj.type) ||
          fileObj.type?.startsWith("video/")
        ) {
          message.error("Video files are not allowed");
          return;
        }

        uploadedKey = await handleDocumentSubmit(fileObj);
        fileName = fileObj.name;
        if (!uploadedKey) return;

        fileName = fileObj.name;
      }

      const payload = {
        wfhStartDate: values.startdate.format("YYYY-MM-DD"),
        wfhEndDate: values.enddate.format("YYYY-MM-DD"),
        wfhNoofDays: String(values.noofdays),
        wfhReason: values.reason,
        reportingManager: userInfo?.reportingmanager,
        objectKey: uploadedKey || "",
        fileName: fileName,
        statusId: data?.requestId ? data?.statusId : "0",
      };
      if (data?.requestId) {
        payload.rejectReason = "";
      }

      const url = data?.requestId
        ? `employeerequest/${userInfo?.userid}/${
            data?.requestId
          }?requestType=${"wfhrequest"}`
        : `employeerequest/wfhrequest`;

      const method = data?.requestId ? "patch" : "post";

      const { code } = await CALL_API(url, method, payload);

      if (code === STATUS_CODE.SUCCESS) {
        await getData();
        setPopupOpen(true);

        setTimeout(() => {
          setPopupOpen(false);
          form.resetFields();
          onCancel();
        }, 2000);
      } else if (code === STATUS_CODE.RECORD_EXIST) {
        message.error(`WFH already exists`);
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleDocumentSubmit = async (file) => {
    try {
      const initPayload = {
        filename: file.name,
        type: file.type,
      };

      const res = await CALL_API(`employeerequest/file`, "POST", initPayload);

      if (res?.code !== STATUS_CODE.SUCCESS) {
        throw new Error("Failed to get upload url");
      }

      const uploadUrl = res?.url;
      console.log("uploadUrl", uploadUrl);
      const key = res?.key; // backend key

      if (!uploadUrl) throw new Error("Upload URL missing");

      // upload to S3
      const putRes = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
        body: file,
      });

      if (!putRes.ok) throw new Error("Upload failed");

      // message.success("File uploaded");

      return key; // ⭐ return object key
    } catch (err) {
      console.error(err);
      message.error("File upload failed");
      return "";
    }
  };

  // ================= DATE CALC =================
  const handleStartDateChange = (date) => {
    const endDate = form.getFieldValue("enddate");
    if (date && endDate && date.isAfter(endDate)) {
      form.setFieldsValue({ enddate: date });
    }
    calculateDays();
  };

  const calculateDays = () => {
    const start = form.getFieldValue("startdate");
    const end = form.getFieldValue("enddate");

    if (start && end) {
      const diff = end.diff(start, "day") + 1;
      form.setFieldsValue({ noofdays: diff > 0 ? diff : 0 });
    } else {
      form.setFieldsValue({ noofdays: 0 });
    }
  };

  return (
    <>
      <ModalWrap
        title={data?.requestId ? "Editing For WFH" : "Applying for WFH"}
        open={open}
        footer={null}
        centered
        width={580}
        onCancel={() => {
          form.resetFields();
          onCancel();
        }}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          onFinish={handleFinish}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Start Date"
                name="startdate"
                rules={[{ required: true, message: "Start date is required" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  onChange={handleStartDateChange}
                  disabledDate={(c) => c && c < dayjs().startOf("day")}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="End Date"
                name="enddate"
                rules={[{ required: true, message: "End date is required" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  onChange={calculateDays}
                  disabledDate={(current) => {
                    const startDate = form.getFieldValue("startdate");
                    if (!startDate) return false;
                    return current && current < dayjs(startDate).startOf("day");
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="No. of days" name="noofdays">
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="Reason for WFH"
            name="reason"
            rules={[
              { required: true, message: "Reason is required" },
              { max: 250, message: "Max 250 chars" },
            ]}
          >
            <TextArea rows={4} maxLength={250} />
          </Form.Item>

          {/* Upload */}
          <Form.Item
            label="Attachment (Optional)"
            name="attachment"
            valuePropName="fileList"
            getValueFromEvent={(e) => e?.fileList}
          >
            <Upload
              beforeUpload={() => false}
              maxCount={1}
              className="custom-upload"
              showUploadList={{
                showRemoveIcon: true,
              }}
            >
              {!form.getFieldValue("attachment")?.length && (
                <div className="upload-box">
                  <UploadOutlined />
                  <span style={{ marginLeft: 8 }}>Upload File</span>
                </div>
              )}
            </Upload>
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <ButtonOutlined
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </ButtonOutlined>

            <ButtonFilled type="primary" htmlType="submit" loading={loading}>
              {data?.requestId ? "Save Changes" : "Submit"}
            </ButtonFilled>
          </div>
        </Form>
      </ModalWrap>
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type={"success"}
        message={data?.requestId ? "Saved" : "Submitted"}
      />
    </>
  );
};

export default ApplyWorkFromHome;
